module.exports = "/images/checkbox-pink-light.svg?1e3bf4ce399644d8287a11d552eda7a4";